(function () {
  'use strict';
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.site-nav__menu.is-open').forEach(function (menu) {
      var toggle = document.querySelector('.site-nav__toggle');
      if (toggle) toggle.click();
    });
  });
})();
